// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__8eWnB","outlet":"Layout_outlet__4oPcs"};